import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router";
import SideBar from "../Sidebar/SideBar";
import { getTagSheets } from "../../Redux/Actions/dataActions";
import { connect } from "react-redux";
import { dominantColors } from "../../Utils/colors";
import "./TagsPage.css";
import SheetsPagePreviewCard from "../SheetsPage/SheetsPagePreviewCard";

function TagsPage({ getTagSheets }) {
  const { tagName } = useParams();
  const decoded = decodeURIComponent(tagName);

  const [sheets, setSheets] = useState([]);
  // ⭐ Farbe einmalig festlegen, um Flackern beim Re-Render zu verhindern
  const [dotColor] = useState(() => 
    dominantColors[Math.floor(Math.random() * dominantColors.length)]
  );

  useEffect(() => {
    getTagSheets(decoded, (data) => {
      setSheets(data);
    });
  }, [decoded, getTagSheets]); // ⭐ Abhängigkeiten sauber eingetragen

  return (
    <Fragment>
      <SideBar />
      <div className="home_content tags_page">
        <div className="header">
          <span
            className="dot"
            style={{ backgroundColor: dotColor }}
          />
          <h1>{decoded}</h1>
        </div>
        <div className="marg">
          {sheets.length === 0 ? (
            <p>loading</p>
          ) : (
            sheets.map((sheet) => {
              return <SheetsPagePreviewCard sheet={sheet} key={sheet.sheet_name} />;
            })
          )}
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({});

const mapActionsToProps = {
  getTagSheets,
};

export default connect(mapStateToProps, mapActionsToProps)(TagsPage);
